import * as React from 'react';
import { Button } from '../../../Forms/Button';
import './style.css';

export interface ShareUrlProps {
  url: string;
}

export interface ShareUrlState {
  canCopyToClipboard: boolean;
}

export enum ShareUrlType {
  Twitter,
  Facebook,
  Email
}

export class ShareUrl extends React.Component<ShareUrlProps, ShareUrlState> {
  constructor(props: ShareUrlProps) {
    super(props);

    this.state = {
      canCopyToClipboard:
        typeof document.queryCommandSupported === 'function'
          ? document.queryCommandSupported('copy')
          : false
    };
  }

  render() {
    const { url } = this.props;
    const { canCopyToClipboard } = this.state;

    return (
      <div className="share-url">
        <p className="share-url-wrapper">
          <span className="share-url-text">
            {url.replace(/https?:\/\//, '')}
          </span>
        </p>
        {canCopyToClipboard ? (
          <Button
            autoFocus={true}
            className="share-url-copy-button"
            type="button"
            onClick={() => this.copyUrlToClipboard(url)}
          >
            Copy URL Link
          </Button>
        ) : null}
      </div>
    );
  }

  private copyUrlToClipboard = (url: string) => {
    /* Create a temporary element to select the link text from */
    const copyElement = document.createElement('span');
    copyElement.textContent = url;
    /* Has to be "visible" for copy to work, so place it off-screen */
    copyElement.style.position = 'absolute';
    copyElement.style.left = '-10000px';

    document.body.appendChild(copyElement);

    // Select the link text
    const selection = window.getSelection();

    if (selection) {
      const range = document.createRange();
      range.selectNodeContents(copyElement);
      selection.removeAllRanges();
      selection.addRange(range);

      // Trigger a copy
      document.execCommand('copy', false, undefined);
    }

    // Clean up our temp element
    document.body.removeChild(copyElement);

    // TODO: Toast to say 'link copied'...?
  };
}

export default ShareUrl;



// WEBPACK FOOTER //
// ./src/app/components/Common/ShareDialog/ShareUrl/index.tsx